import { Component, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
    selector: 'app-textarea-reactive',
    templateUrl: './textarea-reactive.component.html',
    styleUrls: ['./textarea-reactive.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TextareaReactiveComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class TextareaReactiveComponent implements ControlValueAccessor {
  @Input() disabled: boolean = false;
  @Input() label?: string;
  @Input() placeholder?: string = '';

  private innerValue: string = '';

  onChange: any = () => {};
  onTouched: any = () => {};

  constructor() {}

  get value(): string {
    return this.innerValue;
  }

  set value(v: string) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChange(v);
    }
  }

  writeValue(value: any): void {
    if (value !== undefined) {
      this.value = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
